<template>
    <div>
        <div class="level">
            <div class="level-left">
                <h2 class="title is-size-5">{{ headline }}</h2>
            </div>
            <div class="level-right">
                <button class="button is-primary" @click.prevent="openModal(null)">Opret</button>
            </div>
        </div>

        <div class="is-flex flex-col gap-2">
            <CollapsibleLocation
            v-for="location in locationTree"
            :key="location.id"
            :location="location"
            @edit-location="editLocation"
            @new-location="newLocation"
        />
        </div>

        <LocationModal
            :active="modalOpen"
            :location-id="modalLocationId"
            @closed="closeModal"
            :locations="listLocations"
            ref="locationModal"
        />
    </div>
</template>

<script>
import InputText from "@/elements/form/InputText";
import FormField from "@/elements/form/FormField";
import {mapGetters} from "vuex";
import ManufacturerModal from "./components/ManufacturerModal";
import PriceTypeModal from "./components/PriceTypeModal";
import LocationModal from "./components/LocationModal";
import CollapsibleLocation from "./components/CollapsibleLocation";

export default {
    components: { 
        LocationModal, 
        PriceTypeModal, 
        ManufacturerModal, 
        FormField, 
        InputText,
        CollapsibleLocation
    },
    props: {
        headline: String,
        tab: String,
    },
    data() {
        return {
            modalOpen: false,
            modalLocationId: null,
            modalParentId: null,

            locationTree: [],
        }
    },
    computed: {
        ...mapGetters([
            'listLocations',
        ]),
        filtersActive() {
            return this.search !== '';
        },
    },
    watch: {
        listLocations() {
            const newList = this.listLocations.map(location => ({
                id: location.id,
                name: location.name,
                parent_id: location.parent_id,
                full_name: location.full_name,
            }));

            this.locationTree = this.buildTree(newList);
        }
    },
    methods: {
        editLocation(location) {
            this.openModal(location.id)
        },
        newLocation(location) {
            this.openModal()
            this.$nextTick(() => {
                this.$refs.locationModal.parent = location;
            })
        },
        buildTree(data, parent = null) {
            let items = data.filter(item => item.parent_id === parent);
            let result = [];

            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                let children = this.buildTree(data, item.id);

                children.sort((a, b) => {
                    if (a.children === undefined && b.children === undefined) {
                        return 0;
                    }
                    if (a.children === undefined) {
                        return -1;
                    }
                    if (b.children === undefined) {
                        return 1;
                    }
                    return 0;
                });

                if (children.length) {
                    item.children = children;
                }

                result.push(item);
            }

            return result;
        },
        updateUrlParams() {
            let params = {
                tab: this.tab,
            };

            this.$router.push({ query: params })
        },
        openModal(priceTypeId = null) {
            this.modalOpen = true
            this.modalLocationId = priceTypeId
        },
        closeModal() {
            this.modalOpen = false
            this.modalLocationId = null
            this.$store.dispatch('loadLocations')
        },
    },
    mounted() {
        let params = new URLSearchParams(window.location.search)
        this.search = params.get('search') || ''

        this.$store.dispatch('loadLocations')
    }
}
</script>

